import { useCallback } from 'react';
import { useApiMutation } from '../useApiMutation';

interface LinkQueryToGroupParams {
    queryId: string | number;
    groupQueryName: string;
    queryName?: string;
}

export const useLinkQueryToGroup = () => {
    const { mutate, isLoading, error } = useApiMutation<LinkQueryToGroupParams>('/defineGroupQueryForQuery', {
        buildBody: ({ queryId, groupQueryName, queryName }) =>
            JSON.stringify({ queryId: queryId.toString(), groupQueryName, ...(queryName && { queryName }) }),
        defaultError: 'Erreur lors de la liaison au groupe',
    });

    const linkQueryToGroup = useCallback(
        async (params: LinkQueryToGroupParams): Promise<boolean> =>
            !!params.queryId && !!params.groupQueryName.trim() && mutate(params),
        [mutate]
    );

    return { linkQueryToGroup, loading: isLoading, error };
};
